import { Divider } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import {
  FunctionField,
  Show,
  ShowView,
  SimpleShowLayout,
  TextField,
} from 'react-admin';
import { DateField, TrackUser } from '../../components/common';
import { useShowController } from '../../hooks';
import { ResidentShowActions, ResidentShowFields } from '../../resources';
import { constants } from '../../utils';
import { TimelineShowActions } from './TimelineShowActions';

const { eventTypes } = constants;

export const CaseMltcPayerShow = ({
  closeAside,
  classes,
  residentId,
  caseId,
  setRefreshTimeline,
  isViewAdmin,
  ...props
}) => {
  const { resource, id, ...rest } = props;
  const showProps = useShowController({ ...props });
  const { record = {} } = showProps;
  return (
    <div className='row-wrapper'>
      <ShowView
        actions={
          <TimelineShowActions
            closeAside={closeAside}
            title='MLTC Payer Change'
            resourceRecord={record}
            caseId={caseId}
            eventForm='editMltcPayer'
            eventType='mltcPayer'
            eventId={record.id}
            eventName={eventTypes.MLTC_CASE_PAYER_NAME}
            setRefreshTimeline={setRefreshTimeline}
            data={record}
            isViewAdmin={isViewAdmin}
          />
        }
        {...showProps}
      >
        <SimpleShowLayout className={clsx(classes.showLayout)}>
          <TextField
            source='name'
            label='Name'
            textAlign='right'
            className={classes.showItem}
          />
          <DateField
            source='active_date'
            label='Active date'
            textAlign='right'
            className={classes.showItem}
          />
          {/* needed for spacing */}
          <div className={classes.showItem} />
          <FunctionField
            source='mltcPayerCreatedBy.name'
            label='Created by'
            className={classes.showItem}
            render={record => {
              const { mltcPayerCreatedBy, created_at } = record;
              return (
                <TrackUser
                  userField={mltcPayerCreatedBy}
                  timestamp={created_at}
                />
              );
            }}
          />
          <FunctionField
            source='mltcPayerUpdatedBy.name'
            label='Last modified'
            className={classes.showItem}
            render={record => {
              const { mltcPayerUpdatedBy, updated_at } = record;
              return (
                <TrackUser
                  userField={mltcPayerUpdatedBy}
                  timestamp={updated_at}
                />
              );
            }}
          />
          {/* needed for spacing */}
          <div className={classes.showItem} />
        </SimpleShowLayout>
      </ShowView>
      <Divider className={classes.residentDivider} />
      <p className={classes.casesTitle} style={{ paddingLeft: 16 }}>
        Resident info
      </p>
      <Show
        actions={
          <ResidentShowActions
            closeAside={closeAside}
            isResidentPage={false}
            setRefreshTimeline={setRefreshTimeline}
            isViewAdmin={isViewAdmin}
          />
        }
        {...rest}
        resource='residents'
        id={residentId}
      >
        <ResidentShowFields classes={classes} includeCases />
      </Show>
    </div>
  );
};
